import { createModuleUsageLog, CreateModuleUsageLogRequest } from "services";
import { AppThunk } from "store";
import { createModuleUsageLogError, createModuleUsageLogSuccess } from "./reducer";

export const createModuleUsageLogData =
    (data: CreateModuleUsageLogRequest): AppThunk =>
    async (dispatch, getState) => {
        try {
            const state = getState();

            if (!state.signIn.user) {
                return;
            }

            const { accessToken } = state.signIn.user;
            const response = await createModuleUsageLog(data, accessToken);
            dispatch(
                createModuleUsageLogSuccess({
                    data: response.data,
                })
            );
        } catch (error: any) {
            const [first] = error.response.data.statuses;
            dispatch(createModuleUsageLogError({ errorMessage: first.message }));
        }
    };
